import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { rtlCache, theme } from './theme';
import { CacheProvider } from '@emotion/react';
import { BrowserRouter } from 'react-router-dom';
import 'primereact/resources/themes/lara-light-blue/theme.css'; // یا هر تم دیگری
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './App.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <CacheProvider value={rtlCache}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </CacheProvider>
);
